// User actions
export const SET_USER = 'SET_USER'
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOG_OUT = 'LOG_OUT'

export const LOG_IN_TOKEN = 'LOG_IN_TOKEN'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'

// Home page actions
export const FETCH_START = 'FETCH_START'
export const FETCH_SUCCESS = 'FETCH_SUCCESS'
export const FETCH_FAIL = 'FETCH_FAIL'

// post actions
export const FETCH_ONE_START = 'FETCH_ONE_START'
export const FETCH_ONE_SUCCESS = 'FETCH_ONE_SUCCESS'
export const FETCH_ONE_ERROR = 'FETCH_ONE_ERROR'

export const CREATE_SUCCESS = 'CREATE_SUCCESS'
export const CREATE_REQ = 'CREATE_REQ'
export const CREATE_ERROR = 'CREATE_ERROR'
export const RESET = 'RESET'
export const REMOVE_ONE = 'REMOVE_ONE'

export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'

export const DELETE = 'DELETE'
export const DELETE_SUCCESS = 'DELETE_SUCCESS'
export const DELETE_ERROR = 'DELETE_ERROR'
export const LIKE_POST = 'LIKE_POST'

export const FETCH_COMMENTS = 'FETCH_COMMENTS'
export const COMMENT_CREATE = 'COMMENT_CREATE'
export const UPDATE_COMMENT = 'UPDATE_COMMENT'
export const DELETE_COMMENT = 'DELETE_COMMENT'

export const COMMENT_LOADING = 'COMMENT_LOADING'
export const COMMENT_ERROR = 'COMMENT_ERROR'

// follow
export const FOLLOW_USER = 'FOLLOW_USER'
// export const UNFOLLOW_USER = 'UNFOLLOW_USER'

// global actions
export const SET_LOADING = 'SET_LOADING'
export const DONE_LOADING = 'DONE_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const RESET_ERROR = 'RESET_ERROR'

// fetch categories
export const SET_CATEGORIES = 'SET_CATEGORIES'
